import { useForm, Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { CloseSharp } from "@mui/icons-material";
import { BtnAlternative, BtnPrimary } from "../../../../shares/button/Button";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const AddGroups = ({ close }) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  return (
    <div className="relative rounded-2xl w-2/5 bg-white">
      <CloseSharp
        className="absolute top-2 right-[6px] cursor-pointer"
        onClick={close}
      />
      <form
        className="pt-16 pb-10 px-14 text-sm"
      >
        <h6 className="font-extrabold text-md border-b-2 w-full pb-4 mb-6">
          گروه جدید
        </h6>
        <div className="mb-6">
          <label htmlFor="name" className="block mb-1">
            عنوان
          </label>
          <Controller
            name="name"
            control={control}
            defaultValue=""
            rules={{ required: "عنوان را وارد کنید" }}
            render={({ field }) => (
              <TextField
                {...field}
                id="name"
                fullWidth
                error={!!errors.name}
                helperText={errors.name ? errors.name.message : ""}
              />
            )}
          />
        </div>

        <div className="mb-6">
          <label htmlFor="description" className="block mb-1">
            توضیحات
          </label>
          <Controller
            name="description"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                id="description"
                fullWidth
                multiline
                rows={3}
                error={!!errors.description}
                helperText={
                  errors.description ? errors.description.message : ""
                }
              />
            )}
          />
        </div>

        <div className="mb-6">
          <label htmlFor="capacity" className="block mb-1">
            ظرفیت
          </label>
          <Controller
            name="capacity"
            control={control}
            defaultValue=""
            rules={{ required: "ظرفیت کلاس را وارد کنید" }}
            render={({ field }) => (
              <TextField
                {...field}
                id="capacity"
                type="number"
                fullWidth
                error={!!errors.capacity}
                helperText={errors.capacity ? errors.capacity.message : ""}
              />
            )}
          />
        </div>

        <div className="mb-6">
          <label htmlFor="class" className="block mb-1">
            مقطع
          </label>
          <Controller
            name="class"
            control={control}
            defaultValue=""
            rules={{ required: "مقطع را وارد کنید" }}
            render={({ field }) => (
              <Select
                {...field}
                id="class"
                fullWidth
                error={!!errors.class}
                helperText={errors.class ? errors.class.message : ""}
              >
                <MenuItem value="A">class A</MenuItem>
                <MenuItem value="B">class B</MenuItem>
                <MenuItem value="C">class C</MenuItem>
              </Select>
            )}
          />
        </div>
        <div className="mb-6">
          <label htmlFor="class" className="block mb-1">
            مقطع
          </label>
          <Controller
            name="class"
            control={control}
            defaultValue=""
            rules={{ required: "مقطع را وارد کنید" }}
            render={({ field }) => (
              <DatePicker
                // value={call.birth_date}
                required
                inputClass="border border-rule focus:outline-none focus:border-primary-500 rounded-lg py-6 px-4 block w-full appearance-none leading-normal text-md"
                format="YYYY-MM-DD"
                containerClassName="w-full"
                calendar={persian}
                locale={persian_fa}
                placeholder={"تولد"}
                digits={digits}

                // onChange={(e) => setCall({ ...call, birth_date: e.format() })}
              />
            )}
          />
        </div>
        <div className="mr-auto ml-0 w-fit">
          <button
            type="submit"
            className="text-white bg-primary hover:bg-primary-hover transition-all rounded-16 active:bg-primary-active focus:outline-none font-normal text-base rounded-card w-fit py-4 px-8 "
          >
            ثبت گروه
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddGroups;

const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
